/* tslint:disable */
/* eslint-disable */
/**
 * Raberu API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Balance } from '../models';
// @ts-ignore
import type { RequestBillToDepositBalance } from '../models';
/**
 * BalanceApi - axios parameter creator
 * @export
 */
export const BalanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employer/accounting/balance/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestBillToDepositBalance} requestBillToDepositBalance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBillToDepositBalance: async (requestBillToDepositBalance: RequestBillToDepositBalance, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBillToDepositBalance' is not null or undefined
            assertParamExists('requestBillToDepositBalance', 'requestBillToDepositBalance', requestBillToDepositBalance)
            const localVarPath = `/api/v1/employer/accounting/balance/request-bill-to-deposit-balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBillToDepositBalance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceApi - functional programming interface
 * @export
 */
export const BalanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Balance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RequestBillToDepositBalance} requestBillToDepositBalance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestBillToDepositBalance(requestBillToDepositBalance: RequestBillToDepositBalance, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestBillToDepositBalance(requestBillToDepositBalance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.requestBillToDepositBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BalanceApi - factory interface
 * @export
 */
export const BalanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balance(options?: RawAxiosRequestConfig): AxiosPromise<Balance> {
            return localVarFp.balance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestBillToDepositBalance} requestBillToDepositBalance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBillToDepositBalance(requestBillToDepositBalance: RequestBillToDepositBalance, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestBillToDepositBalance(requestBillToDepositBalance, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceApi - interface
 * @export
 * @interface BalanceApi
 */
export interface BalanceApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApiInterface
     */
    balance(options?: RawAxiosRequestConfig): AxiosPromise<Balance>;

    /**
     * 
     * @param {RequestBillToDepositBalance} requestBillToDepositBalance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApiInterface
     */
    requestBillToDepositBalance(requestBillToDepositBalance: RequestBillToDepositBalance, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * BalanceApi - object-oriented interface
 * @export
 * @class BalanceApi
 * @extends {BaseAPI}
 */
export class BalanceApi extends BaseAPI implements BalanceApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balance(options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RequestBillToDepositBalance} requestBillToDepositBalance 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public requestBillToDepositBalance(requestBillToDepositBalance: RequestBillToDepositBalance, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).requestBillToDepositBalance(requestBillToDepositBalance, options).then((request) => request(this.axios, this.basePath));
    }
}

